export const MAIN_DATA_LOAD = 'MAIN_DATA_LOAD';
export const MAIN_DATA_LOADED = 'MAIN_DATA_LOADED';
export const MAIN_DATA_ERROR = 'MAIN_DATA_ERROR';
